var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c("pre", [
            _vm._v(
              "      Use the wf-product-detail-state component to display information about the product detail page's current state.\n      Define content in the component's default slot.\n    "
            )
          ])
        ],
        { selectedColor: _vm.selectedColor }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }